module.exports = __webpack_public_path__ + "media/ordernotification.baf3674a.wav";